import(/* webpackMode: "eager" */ "/Users/dowon/WebstormProjects/employability-assessment-system/src/app/error.tsx");
